import React from 'react'
import { PersonLiteDto } from '../../../api/person/models/PersonDto'
import { CandidateReviewStatus } from '../../../api/role/models/CandidateReviewStatus'
import { getProfilePicUrl, formatPersonName } from '../../../utils/personUtils'
import { BadgeColor } from '../../common/badge/badgeTypes'
import Badge from '../../common/badge/Badge'

interface Props {
    person?: PersonLiteDto
    nameFallback: string
    status: CandidateReviewStatus
}

// Map CandidateReviewStatus to BadgeColor
function getBadgeColor(status: CandidateReviewStatus): BadgeColor {
    switch (status) {
        case CandidateReviewStatus.COMPLETE:
            return BadgeColor.Success
        case CandidateReviewStatus.IN_PROGRESS:
            return BadgeColor.Progress
        case CandidateReviewStatus.NOT_STARTED:
        default:
            return BadgeColor.Error
    }
}

function statusLabel(status: CandidateReviewStatus) {
    switch (status) {
        case CandidateReviewStatus.COMPLETE:
            return 'Complete'
        case CandidateReviewStatus.IN_PROGRESS:
            return 'In Progress'
        case CandidateReviewStatus.NOT_STARTED:
        default:
            return 'Not Started'
    }
}

export default function SharedUserCard({
    person,
    nameFallback,
    status,
}: Props): React.JSX.Element {
    const avatarUrl = person
        ? getProfilePicUrl(person, true)
        : '/no-profile-pic.svg'
    const displayName = person ? formatPersonName(person) : nameFallback

    return (
        <div className="flex items-center gap-3 p-3 border rounded-lg bg-white w-full">
            <img
                src={avatarUrl}
                className="w-10 h-10 rounded-full object-cover"
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = '/no-profile-pic.svg'
                }}
            />
            <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-gray-900 truncate">
                    {displayName}
                </div>
            </div>
            <Badge color={getBadgeColor(status)}>{statusLabel(status)}</Badge>
        </div>
    )
}
